import type { ReactNode } from 'react'

import { cn } from '../../utils/cn'
import { frameSize, type DesignFrame } from '../../utils/geometry'

type ChartCanvasProps = {
  frame: DesignFrame
  className?: string
  children: ReactNode
}

/**
 * Caps the card at its Figma width and hosts a fixed-size canvas inside a horizontal
 * scroller, so the artwork never distorts on narrow viewports.
 */
export const ChartCanvas = ({ frame, className, children }: ChartCanvasProps) => (
  <section
    className={cn('w-full overflow-hidden rounded-[18px]', className)}
    style={{ maxWidth: frame.width }}
  >
    <div className="overflow-x-auto scrollbar-hide">
      <div className="relative" style={frameSize(frame)}>
        {children}
      </div>
    </div>
  </section>
)
